export const VALIDATE_FINDANIFA = 'VALIDATE_FINDANIFA'
export const FINDANIFA_CLEAR_VALIDATION_STATE = 'FINDANIFA_CLEAR_VALIDATION_STATE'

export const clearisInvalid  = function () {
  return {
    type: FINDANIFA_CLEAR_VALIDATION_STATE
  }
}
